import { EmptyState, ErrorAlert, Notice, linkStyles, PageHeader, cardStyles } from '@lumlab/platform-ui';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { useAccess } from '@lumlab/platform-admin/web';
import { authClient } from '../app/auth.ts';
import { useAccountState } from '../app/account.ts';
import { products } from '../products.ts';

export function HomePage() {
    const { t } = useTranslation();
    const session = authClient.useSession();
    const access = useAccess(session.data?.user.id);
    const account = useAccountState(session.data?.user.id);
    const available = products.filter((product) => access.data?.products.includes(product.id));
    return (
        <>
            <PageHeader title={t('platform.shell.welcome')} />
            {account.data?.selection && (
                <Notice>
                    {t('platform.onboarding.saved')}{' '}
                    <Link to="/welcome" className={linkStyles}>
                        {t('platform.onboarding.change')}
                    </Link>
                </Notice>
            )}
            {access.error && <ErrorAlert error={access.error} />}
            {access.data && available.length === 0 && (
                <EmptyState title={t('platform.shell.noProducts')} description={t('platform.shell.noProductsHelp')} />
            )}
            <div className="grid gap-4 md:grid-cols-2">
                {available.map((product) => (
                    <Link
                        key={product.id}
                        className={`${cardStyles} group flex flex-col gap-1 transition-colors hover:border-brand`}
                        to={`/${product.id}`}
                    >
                        <span className="flex items-center justify-between gap-4">
                            <span className="font-display text-lg font-semibold">
                                {t(`${product.id}.product.name`)}
                            </span>
                            <svg
                                aria-hidden="true"
                                viewBox="0 0 24 24"
                                className="size-5 text-muted transition-transform group-hover:translate-x-0.5 group-hover:text-brand"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <path d="M5 12h14M13 6l6 6-6 6" />
                            </svg>
                        </span>
                        <span className="text-muted">{t(`${product.id}.product.tagline`)}</span>
                    </Link>
                ))}
            </div>
        </>
    );
}
